// extracted by mini-css-extract-plugin
export var cookList = "index-module--cookList--ZkAft";
export var closedRedBorder = "index-module--closedRedBorder--2o7oC";
export var mintClosed = "index-module--mintClosed--1Za6Z";
export var statusSpace = "index-module--statusSpace--3Ojrz";
export var emptyCookList = "index-module--emptyCookList--4ySjl";
export var cookListItemWrapper = "index-module--cookListItemWrapper--2mmR1";
export var cookListWrapper = "index-module--cookListWrapper--1W6pV";
export var availText = "index-module--availText--2OQ5G";
export var burgerList = "index-module--burgerList--3uR4R";